import { api } from "@/api";

class API {
  static getListPolicy(payload) {
    return api.get(`/v1/garantia/apolices${payload}`);
  }
  static getSituation() {
    return api.get("/v1/garantia/apolices/situacao/suggest");
  }
  static getEmission() {
    return api.get("/v1/garantia/apolices/tiposemissao/suggest");
  }
  static getInsured(payload) {
    return api.get(`/v1/segurados/cotacao${payload}`);
  }
  static postPolicy(payload) {
    return api.post("/v1/garantia/apolices", payload);
  }
  static getCurrentPolicy(payload) {
    return api.get(`/v1/garantia/apolices/${payload}`);
  }
  static putPolicy(value) {
    return api.put(`/v1/garantia/apolices/${value.id}`, value.payload);
  }
  static getListInvoice(payload) {
    return api.get(`/v1/faturas${payload}`);
  }
  static postInvoice(payload) {
    return api.post("/v1/faturas", payload);
  }
  static putInvoice(value) {
    return api.put(`/v1/faturas/${value.id}`, value.payload);
  }
  static getCurrentInvoice(payload) {
    return api.get(`/v1/faturas/${payload}`);
  }
  static getListTypeEndorsement() {
    return api.get("/v1/garantia/apolices/endossos/tipos/suggest");
  }
  static postEndorsement(value) {
    return api.post(
      `/v1/garantia/apolices/${value.id}/endossos`,
      value.payload
    );
  }
  static putEndorsement(value) {
    return api.put(
      `/v1/garantia/apolices/${value.id}/endossos/${value.endosso}`,
      value.payload
    );
  }
  static getCurrentEndorsement(value) {
    return api.get(
      `/v1/garantia/apolices/${value.id}/endossos/${value.endosso}`
    );
  }
  static getCurrentPolicyEdit(payload) {
    return api.get(`/v1/garantia/apolices/${payload}/edicao`);
  }
  static putInactivateInvoice(value) {
    return api.put(`/v1/faturas/${value.id}/inativar`, value.payload);
  }
  static getInactivateItems() {
    return api.get("/v1/faturas/motivosinativacao/suggest");
  }
  static postCancelPolicy(value) {
    return api.post(
      `/v1/garantia/apolices/${value.id}/cancelamento/solicitacao`,
      value.payload
    );
  }
  static postRefuseCancelPolicy(value) {
    return api.post(
      `/v1/garantia/apolices/${value.id}/cancelamento/reprovacao`,
      value.payload
    );
  }
  static postRequestEndorsement(value) {
    return api.post(
      `/v1/garantia/apolices/${value.id}/endossos/solicitacoes`,
      value.payload
    );
  }
  static getCurrentRequestEndorsement(value) {
    return api.get(
      `/v1/garantia/apolices/${value.id}/endossos/solicitacoes/${value.endosso}`
    );
  }
  static putRequestEndorsement(value) {
    return api.put(
      `/v1/garantia/apolices/${value.id}/endossos/solicitacoes/${value.endosso}`,
      value.payload
    );
  }
  static getItemsEndorsement(payload) {
    return api.get(`/v1/garantia/apolices/${payload}/endossos/suggest`);
  }
  static getCriticismEndorsement(value) {
    return api.get(
      `/v1/garantia/apolices/${value.id}/endossos/solicitacoes/${value.endosso}/criticas`
    );
  }
  static postCriticismEndorsement(value) {
    return api.post(
      `/v1/garantia/apolices/${value.id}/endossos/solicitacoes/${value.endosso}/criticas`,
      value.payload
    );
  }
  static postResendCriticismEndorsement(value) {
    return api.post(
      `/v1/garantia/apolices/${value.id}/endossos/solicitacoes/${value.endosso}/criticas/${value.critica}/reenviar`
    );
  }
  static putResolveCriticismEndorsement(value) {
    return api.put(
      `/v1/garantia/apolices/${value.id}/endossos/solicitacoes/${value.endosso}/criticas/${value.critica}/regularizar`
    );
  }
  static postCancelRequestEndorsement(value) {
    return api.post(
      `/v1/garantia/apolices/${value.id}/endossos/solicitacoes/${value.endosso}/reprovar`
    );
  }
  static getOptionsPolicy(payload) {
    return api.get(`/v1/garantia/apolices/opcoes`, {
      params: {
        submodalidade_id: payload
      }
    });
  }
}

export default API;
